import 'css-chunksrc/client/scenes/workloads/wbs/task/styles.scss';export default {
  "task": "_task_kvjix_1",
  "contextualMenu": "_contextualMenu_kvjix_7",
  "taskDetails": "_taskDetails_kvjix_11",
  "name": "_name_kvjix_18",
  "icon": "_icon_kvjix_34",
  "taskAdvancement": "_taskAdvancement_kvjix_38",
  "allocations": "_allocations_kvjix_44",
  "text": "_text_kvjix_51",
  "completionDate": "_completionDate_kvjix_57",
  "tick": "_tick_kvjix_63",
  "late": "_late_kvjix_70",
  "displayedContextualMenu": "_displayedContextualMenu_kvjix_79",
  "taskStatus": "_taskStatus_kvjix_87",
  "placeholder": "_placeholder_kvjix_93",
  "row": "_row_kvjix_98",
  "comments": "_comments_kvjix_104",
  "constrained": "_constrained_kvjix_108",
  "constraintsPopup": "_constraintsPopup_kvjix_112"
};